import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ExpertiseTitle = styled.h2`
  border: none;
  margin: 0;
  font-weight: ${fromTheme('font_weight_bolder')};
  font-size: ${fromTheme('font_size_heading_4')};
  color: ${fromTheme('color_text')};
`;

export const ExpertiseSectionContainer = styled.div`
  margin-top: ${fromTheme('spacing_large')};
`;

export const ExpertiseSectionTitle = styled.h3`
  margin: 0 0 ${fromTheme('spacing_medium')} 0;
  font-weight: ${fromTheme('font_weight_bold')};
  font-size: ${fromTheme('font_size_heading_5')};
  color: ${fromTheme('color_text')};
`;

export const ExpertiseEntryContainer = styled.li`
  margin-bottom: ${fromTheme('spacing_small')};
  font-size: ${fromTheme('font_size')};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ExpertiseList = styled.ul`
  margin: 0;
  padding: 0 0 0 ${fromTheme('spacing_medium')};
`;
